<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>管理系統</f7-nav-title>
    </f7-navbar>

    <f7-list>
      <f7-list-item link="manage-all-items" title="管理所有品項" link-view="#main-view" link-close-panel></f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  dependencies: [
    'platformUtils'
  ],
  data () {
    return {
      platform: process.env.VUE_APP_PLATFORM
    }
  },
  created () {
    this.setStore(this.storeIdProp)
  },
  props: {
    storeIdProp: String
  },
  components: {
  },
  methods: {
    ...mapActions(['setStore']),
    getAllEmployees () {}
  }
}
</script>
